export default new Map<string, IdealLink>([
  [
    '5',
    {
      label: '5,00',
      amount: 5,
      href: 'https://www.ing.nl/payreq/m/?trxid=mGbhxbdk1OnodZctSlctFTVIQ58eeGxk',
    },
  ],
  [
    '20',
    {
      label: '20,00',
      amount: 20,
      href: 'https://www.ing.nl/payreq/m/?trxid=mGbhxbdk1OnodZctSlctFTVIQ58eeGxk',
    },
  ],
  [
    '50',
    {
      label: '50,00',
      amount: 50,
      href: 'https://www.ing.nl/payreq/m/?trxid=mop62j558DTTHfZtr0j0f8qakGhF9Ij9',
    },
  ],
  [
    'any',
    {
      label: 'Bedrag naar keuze',
      href: 'https://www.ing.nl/payreq/m/?trxid=e3I1VFE2MMD9NReac2mKGeAtrl1KBjhn',
    },
  ],
])
